import React from 'react';

// Styles & Assets
import styles from './ButtonsPolls.module.css';
import { MdAdd } from 'react-icons/md';
import { RiPencilFill } from 'react-icons/ri';

// Hooks
import { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';
import AddPollDialog from '../AddPollDialog/AddPollDialog';
import EditPollDialog from '../EditPollDialog/EditPollDialog';

// Interfaces
import { Case, Patient } from '../../../interfaces/Patient';

const ButtonsPolls: React.FC<{
    patientID: Patient['id']
    caseID: Case['id']
    readOnly: boolean
}> = ({ patientID, caseID, readOnly }) => {

    const [showAddPollDialog, setShowAddPollDialog] = useState(false);
    const [showEditPollDialog, setShowEditPollDialog] = useState(false);

    return (
        <>
            <div className={styles.container}>
                <button className={styles.buttonPolls} onClick={() => setShowAddPollDialog(true)} disabled={readOnly}>
                    <MdAdd />
                </button>
                <button className={styles.buttonPolls} onClick={() => setShowEditPollDialog(true)} disabled={readOnly}>
                    <RiPencilFill />
                </button>
            </div>
            <Modal show={showAddPollDialog} setShowModal={setShowAddPollDialog}>
                {showAddPollDialog &&
                    <AddPollDialog
                        showModal={setShowAddPollDialog}
                        patientID={patientID}
                        caseID={caseID}
                    />
                }
            </Modal>
            <Modal show={showEditPollDialog} setShowModal={setShowEditPollDialog}>
                {showEditPollDialog &&
                    <EditPollDialog
                        showModal={setShowEditPollDialog}
                        patientID={patientID}
                        caseID={caseID}
                    />
                }
            </Modal>
        </>
    );
};

export default ButtonsPolls;